import styled from "styled-components"

import { ContainerWithColor } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

export const SubpageContainer = styled(ContainerWithColor)`
    background-color: #ffffff;
    border-radius: 16px;
    border: 1px solid #e9ecef;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.12);

    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    max-width: 720px;
    margin: 1.5rem auto 0 auto;

    padding: 1.5rem;

    font-size: 16px;

    @media (min-width: 768px) {
        padding: 2rem;
    }
`

export const NextElectionBannerWrapper = styled.div``

export const PlaceholderSection = styled.div`
    /* No external margins; rely on SubpageContainer gap for vertical spacing */
`
